(function() {
'use strict';

    angular
        .module('app')
        .controller('choicePerSerilNoModalController', choicePerSerilNoModalController);
        
    function choicePerSerilNoModalController($uibModal,data,$uibModalInstance) {
        var vm = this;
        vm.choiceSeirlNo=choiceSeirlNo;
        vm.data=data;
        
        function choiceSeirlNo(item){
            return $uibModalInstance.close(item);
        }
    }
})();